module.exports = __webpack_public_path__ + "static/media/bike_ride.6d305ad8.png";